<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const open = ref(false);

const menuDropdown = ref(null);

function toggleDropdown() {
    open.value = !open.value;
}

function clickOutside(e) {
    if (!menuDropdown.value.contains(e.target)) {
        open.value = false;
    }
}

onMounted(() => {
    window.addEventListener('click', clickOutside);
});

onBeforeUnmount(() => {
    window.removeEventListener('click', clickOutside);
});
</script>

<template>
    <div ref="menuDropdown" class="relative">
        <div @click="toggleDropdown">
            <slot name="dropdown-btn"></slot>
        </div>
        <div
            v-if="open"
            class="absolute right-0 z-10 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="menu-button"
            tabindex="-1"
        >
            <div class="text-left" role="none">
                <slot name="dropdown-content"></slot>
            </div>
        </div>
    </div>
</template>
<style scoped>
.ring-opacity-5 {
    --tw-ring-opacity: 0;
}
</style>
